import { render, staticRenderFns } from "./estimate-options-send-to-customers.vue?vue&type=template&id=83e8a5f2&scoped=true"
import script from "./estimate-options-send-to-customers.vue?vue&type=script&lang=js"
export * from "./estimate-options-send-to-customers.vue?vue&type=script&lang=js"
import style0 from "./estimate-options-send-to-customers.vue?vue&type=style&index=0&id=83e8a5f2&prod&scoped=true&lang=css"
import style1 from "./estimate-options-send-to-customers.vue?vue&type=style&index=1&id=83e8a5f2&prod&lang=css"
import style2 from "./estimate-options-send-to-customers.vue?vue&type=style&index=2&id=83e8a5f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83e8a5f2",
  null
  
)

export default component.exports